import React from 'react';
import NotFoundPage from './NotFoundPage';
import { useLocation, useParams } from 'react-router-dom';
import AnswerPage from './AnswerPage';
import Article from './Article';

const ArticlePage: React.FC = () => {
    // Get the wildcard portion of the route
    const { '*': route } = useParams<{ '*': string }>();

    // Get the 'from' query parameter
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const from = queryParams.get('from') || 'pages';

    // Split the route into parts, filtering out empty strings
    const parts = route?.split('/').filter(Boolean) || [];

    if (parts.length > 1) {
        // If we have multiple parts, treat it as a question view
        const questionId = parseInt(parts[0]);
        const slug = parts[1];

        if (isNaN(questionId)) {
            return <NotFoundPage />;
        }

        return <AnswerPage questionId={questionId} slug={slug} />;
    }

    // Otherwise, treat it as an article view
    if (parts.length === 1) {
        return <Article slug={parts[0]} from={from} />;
    }

    return <NotFoundPage />;
};

export default ArticlePage;
